import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "button-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_7 = {
  type: "button",
  class: "btn btn-default",
  "data-bs-dismiss": "modal"
}

import { ref, onMounted, onBeforeUnmount } from 'vue'
    import { Modal } from 'bootstrap'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleModal',
  props: {
        modalSize: {type: String, required:false, default: '' },
        rejectLabel: { type: String, required: false, default: "Cancel" },
        acceptLabel: { type: String, required: false, default: "Yes" },
        title: { type: String, required: true },
        showFooter: { type: Boolean, required: false, default: true }
    },
  emits: ['hidden','accepted'],
  setup(__props, { emit: emits }) {

const props = __props

    

    

    const modalRef = ref<Element | null>(null)
    const modal = ref<Modal | null>(null)

    function acceptModal() {
        emits('accepted')
    }

    onMounted(() => {
        if(modalRef.value !== null) {
            modal.value = new Modal(modalRef.value)
            modal.value.show()
            modalRef.value.addEventListener('hidden.bs.modal', function() {
                emits('hidden')
            })
        }
    })

    onBeforeUnmount(() => {
        if(modal.value) {
            modal.value.hide()
        }
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    ref: (el) => { modalRef.value = el as Element},
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered modal-dialog-scrollable", 'modal-' + props.modalSize])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createElementVNode("h5", _hoisted_3, _toDisplayString(props.title), 1),
            _hoisted_4
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        (__props.showFooter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "footer", {}, () => [
                _createElementVNode("button", _hoisted_7, _toDisplayString(props.rejectLabel), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (acceptModal()))
                }, _toDisplayString(props.acceptLabel), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 512))
}
}

})